<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 lg4 xl3>
        <Login @login="onLogin" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Login from '../components/Login'

export default {
  components: {
    Login,
  },

  metaInfo: {
    title: 'Login',
  },

  methods: {
    onLogin() {
      const nextParam = this.$route.query.next
      if (
        nextParam &&
        nextParam.startsWith('/') &&
        !/^https?:\/\//i.test(nextParam)
      ) {
        this.$router.push(nextParam)
      } else {
        this.$router.push({ name: 'home' })
      }
    },
  },

  mounted() {
    document.body.classList.add('login-page')
  },

  beforeDestroy() {
    document.body.classList.remove('login-page')
  },
}
</script>

<style lang="stylus">
@import '~vuetify/src/stylus/settings/_theme';

body.login-page #app {
  background: url('../assets/zigzag-bg-17p-fade.jpg') no-repeat;
  background-size: cover;
}
</style>
